import type { Editor } from '@tiptap/core';
import type { PricingType } from '@/theme/uboTheme';
import type { InvestmentLabelLanguage } from '@/types';
import {
  buildInvestmentHeaderRowJson,
  getInvestmentTableLabels,
  normalizeInvestmentLabelLanguage,
} from '@/editor/investmentTableLabels';

/**
 * Zet `labelLanguage` op de groep en vervangt alle tabelkoppen + totaalregelteksten binnen die groep.
 */
export function applyInvestmentGroupLabelsLanguage(
  editor: Editor,
  groupPos: number,
  lang: InvestmentLabelLanguage,
): void {
  const { state } = editor;
  const groupNode = state.doc.nodeAt(groupPos);
  if (!groupNode || groupNode.type.name !== 'investmentGroupNode') return;

  const L = getInvestmentTableLabels(normalizeInvestmentLabelLanguage(lang));
  const tr = state.tr;

  tr.setNodeMarkup(groupPos, undefined, { ...groupNode.attrs, labelLanguage: lang });

  let currentPricing: PricingType = 'fixed';
  let pos = groupPos + 1;

  for (let i = 0; i < groupNode.childCount; i++) {
    const child = groupNode.child(i);
    const childPos = pos;
    pos += child.nodeSize;

    if (child.type.name === 'investmentHeaderNode' && !child.attrs.isMainHeader) {
      currentPricing = (child.attrs.pricingType as PricingType) || 'fixed';
    } else if (child.type.name === 'table') {
      const firstRow = child.child(0);
      if (firstRow?.type?.name === 'tableRow') {
        const rowFrom = childPos + 1;
        const rowTo = rowFrom + firstRow.nodeSize;
        const headerRowJson = buildInvestmentHeaderRowJson(currentPricing, L);
        const mappedFrom = tr.mapping.map(rowFrom);
        const mappedTo = tr.mapping.map(rowTo);
        tr.replaceWith(mappedFrom, mappedTo, state.schema.nodeFromJSON(headerRowJson));
      }
    } else if (child.type.name === 'investmentTotalNode') {
      const mappedPos = tr.mapping.map(childPos);
      tr.setNodeMarkup(mappedPos, undefined, { ...child.attrs, label: L.totalRow });
    }
  }

  editor.view.dispatch(tr);
}
